<template>
  <div style="display:inline-block">
    <a href="javascript:void(0);" @click="showModal = true"
      ><span class="glyphicon glyphicon-question-sign"></span> <slot></slot
    ></a>
    <transition name="modal">
      <div v-if="showModal" id="modal_help" class="modal-mask" @click="showModal = false">
        <div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
          <div class="modal-container modal-dialog">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <a
                  href="javascript:void(0)"
                  class="close"
                  @click="$emit('close')"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fas fa-times"></i>
                </a>
                <div class="row" style="margin-bottom: 0">
                  <div class="col s10" style="color: black">
                    <a :href="link" target="_blank" class="btn btn-sm btn-primary">
                      <span class="glyphicon glyphicon-resize-full"></span> View full screen</a
                    >
                  </div>
                </div>
              </div>
              <div class="modal-body" style="padding: 0">
                <slot name="body">
                  <iframe
                    :src="link"
                    style="width: 100%;box-sizing: border-box;display: block;border: none;height: 80vh;"
                  >
                    <p>Your browser does not support iframes.</p>
                  </iframe>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['link'],
  data: function() {
    return {
      showModal: false
    }
  },
  mounted: function() {
    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.showModal = false
      }
    })
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ModalHelp.vue